module.exports = __webpack_public_path__ + "img/home-head-bg.b2e9ee81.png";